import { ThemeOptions } from "@material-ui/core/styles/createMuiTheme";
import voucherDefault from "../images/VoucherDefault.png";
import collectFromPickup from "../images/CollectFromPickup.jpg";
import trackingBg from "../images/tracking.jpg";
import mapBg from "../images/map.jpg";
import collectFromPickupMobile from "../images/MobileBackgrounds/CollectFromPickup.png";
export const images = {
  trackingBg,
  voucherDefault,
  collectFromPickup,
  mapBg,
  collectFromPickupMobile
};
export default {
  typography: {
    fontFamily: `"Roboto", "PlutoSansRegular", sans-serif`
  },
  overrides: {
    MuiButton: {
      label: {
        fontFamily: "PlutoSansRegular"
      },
      contained: {
        "&$disabled": {
          boxShadow: "2px 2px 3px 0 rgba(0, 0, 0, 0.4)"
        }
      }
    }
  },
  shape: {
    borderRadius: 3
  },
  palette: {
    background: {
      default: "#fff",
      overlay: "rgba(0, 0, 0, 0.5)"
    },
    error: {
      main: "#dc0032"
    },
    action: {
      disabled: "#fff",
      disabledBackground: "#b7b9bd"
    },
    gradient: {
      confirm: "linear-gradient(#76b55a, #429321)",
      reject: "linear-gradient(#dc0032, #9f041b)"
    }
  }
};